import React, { useState, useEffect } from "react";
import "../styles/Loanproviders.css";
import { useNavigate } from "react-router-dom";
import { buildUrlWithUTM } from '../utils/utmUtils.js';
import PortalHeader from "./PortalHeader";
import varthanalogo from "../assets/varthanalogo.png";
import finzlogo from "../assets/finzlogo.png";
import aksharlogo from "../assets/aksharlogo.png";

const loanProviders = [
  {
    id: 1,
    name: "Varthana Finance",
    provlogo: varthanalogo,
    baseRate: 0.06,
    eligibility: ["CIBIL score of 700", "CIBIL score of"],
  },
  {
    id: 2,
    name: "Finz Payments",
    provlogo: finzlogo,
    baseRate: 0.08,
    eligibility: ["CIBIL score of 650", "CIBIL score of"],
  },
  {
    id: 3,
    name: "Akshar Fees",
    provlogo: aksharlogo,
    baseRate: 0.07,
    eligibility: ["CIBIL score of 600", "CIBIL score of"],
  },
];

const LoanPlans = () => {
  const [amount, setAmount] = useState(0);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const [agree, setAgree] = useState(false);
  const [tenures, setTenures] = useState({1: 12, 2: 3, 3: 6});
  const navigate = useNavigate();

  const handlePlanToggle = (planId) => {
    setSelectedPlans(prev =>
      prev.includes(planId)
        ? prev.filter(id => id !== planId)
        : [...prev, planId]
    );
  };

  const handleSubmit = async () => {
    if (!agree || selectedPlans.length === 0) return alert("Please agree to the terms and select at least one plan.");
    const application_id = localStorage.getItem('application_id');
    for (const planId of selectedPlans) {
      const plan = loanProviders.find(p => p.id === planId);
      const tenure = tenures[planId] || 12;
      // You can add more fields as needed
      await fetch('/api/loan-provider-selections', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          application_id, // required by backend
          loan_provider_name: plan.name,
          loan_amount: amount,
          loan_tenure: tenure
        })
      });
    }
    navigate(buildUrlWithUTM("/portal/loan-thankyou"), {
      state: { providerName: selectedPlans.map(id => loanProviders.find(p => p.id === id).name).join(', '), amount },
    });
  };

  return (
    <>
      <PortalHeader>
        <nav className="nav-links">
          <a href={buildUrlWithUTM("/portal")} className="nav-link" onClick={(e) => { e.preventDefault(); window.location.href = buildUrlWithUTM('/portal'); }}>Home</a>
        </nav>
        <button className="logout-button" onClick={() => {
          localStorage.clear();
          window.location.href = buildUrlWithUTM('/portal/login');
        }}>
          Logout
        </button>
      </PortalHeader>

      <div className="loan-plans-container">
        <h2>Payment</h2>
        <p className="payment-desc">Enter your loan amount and choose your preferred tenure for bank. You can proceed with one, two, or all three cards based on your preference.</p>

        <label>Enter loan amount:</label>
        <input
          type="number"
          placeholder="Enter amount"
          value={amount}
          onChange={(e) => setAmount(Number(e.target.value))}
        />

        <div className="plans-grid">
          {loanProviders.map((plan) => {
            let tenureOptions = [];
            let interestRate = 0;
            let cibilScore = '';
            let tenure = tenures[plan.id] || 12;
            let emi = 4000;
            let formattedInterestRate = '';
            let extraEMI = null;

            if (plan.id === 1) { // Varthana
              tenureOptions = [12, 18];
              interestRate = tenure === 18 ? 7.5 : 8.5;
              cibilScore = '700';
              const interest = amount * (interestRate / 100) * (tenure / 12);
              emi = amount > 0 && tenure > 0 ? ((amount + interest) / tenure).toFixed(2) : 4000;
              formattedInterestRate = interestRate.toFixed(2);
            } else if (plan.id === 2) { // Finz
              tenureOptions = [3, 6, 9, 12];
              const rateMap = {3: 5, 6: 6.75, 9: 9.25, 12: 12};
              interestRate = rateMap[tenure] || 12;
              cibilScore = '550';
              const interest = amount * (interestRate / 100) * (tenure / 12);
              emi = amount > 0 && tenure > 0 ? ((amount + interest) / tenure).toFixed(2) : 4000;
              formattedInterestRate = interestRate.toFixed(2);
            } else if (plan.id === 3) { // Akshar
              tenureOptions = [6, 9, 12, 15];
              interestRate = 12.0;
              cibilScore = '650';
              // Show two EMIs: one for 12%, one for 18%
              const interest12 = amount * (12 / 100) * (tenure / 12);
              const emi12 = amount > 0 && tenure > 0 ? ((amount + interest12) / tenure).toFixed(2) : 4000;
              const interest18 = amount * (18 / 100) * (tenure / 12);
              const emi18 = amount > 0 && tenure > 0 ? ((amount + interest18) / tenure).toFixed(2) : 4000;
              emi = emi12;
              extraEMI = emi18;
              formattedInterestRate = '12.00 & 18.00';
            }

            const isSelected = selectedPlans.includes(plan.id);
            return (
              <div key={plan.id} className={`plan-card ${isSelected ? "selected" : ""}`}>
                <div className="header">
                  <img src={plan.provlogo} alt={plan.name} className="logo" />
                  <span className="title">{plan.name}</span>
                </div>
                <div className="meta" style={{alignItems: 'flex-end', display: 'flex', justifyContent: 'space-between'}}>
                  <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                      <label>Estimated EMI</label>
                      {plan.id === 3 ? (
                        <>
                          <div className="value" style={{fontWeight:600, fontSize:'20px', color:'#3D3D3D'}}>Rs {emi}/month</div>
                          <div className="value" style={{fontWeight:600, fontSize:'20px', color:'#3D3D3D'}}>Rs {extraEMI}/month</div>
                        </>
                      ) : (
                        <div className="value" style={{fontWeight:600, fontSize:'20px'}}>Rs {emi}/month</div>
                      )}
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '1.5rem'}}>
                      <label style={{marginBottom: '4px'}}>Tenure</label>
                      <select
                        value={tenure}
                        onChange={e => setTenures(t => ({...t, [plan.id]: Number(e.target.value)}))}
                        className="tenure-dropdown"
                        disabled={plan.id === 1 && tenureOptions.length === 1}
                      >
                        {tenureOptions.map(val => (
                          <option key={val} value={val}>{val} months</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="eligibility">
                  <div style={{display:'flex',alignItems:'center',marginBottom:'6px'}}>
                    <span style={{color:'#1976d2',fontSize:'18px',marginRight:'8px'}}>✔</span>
                    <span className="feature-label">Interest Rate:</span>&nbsp;
                    {plan.id === 3 ? (
                      <span style={{color:'#545454'}}>12.00 % to 18.00 % per annum</span>
                    ) : (
                      <span style={{color:'#545454'}}>{formattedInterestRate} % per annum</span>
                    )}
                  </div>
                  <div style={{display:'flex',alignItems:'center'}}>
                    <span style={{color:'#1976d2',fontSize:'18px',marginRight:'8px'}}>✔</span>
                    <span className="feature-label">Minimum CIBIL Score Required:</span>&nbsp;<span style={{color:'#545454'}}>{cibilScore}</span>
                  </div>
                </div>
                <button
                  className={`choose-btn${isSelected ? ' selected' : ''}`}
                  onClick={() => handlePlanToggle(plan.id)}
                >
                  {isSelected ? 'Selected' : 'Choose this plan'}
                </button>
              </div>
            );
          })}
        </div>

        <div className="disclaimer">
          <input
            type="checkbox"
            checked={agree}
            onChange={() => setAgree(!agree)}
          />
          <span>
            I understand that applying for a loan does not guarantee approval. The final decision will be made by the
            lending partner after reviewing my documents and eligibility.
          </span>
        </div>

        <button className="submit-btn" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </>
  );
};

export default LoanPlans;